module.exports = __webpack_public_path__ + "img/christmas-window-2.e09b1adb.svg";